export default __webpack_public_path__ + "static/media/canpou.e812bd69.jpg";